var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({backgroundColor:_vm.layout?.pageBackground?.color})},[(_vm.layout)?_c('section',{staticClass:"innovation-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"block-title-w",domProps:{"innerHTML":_vm._s(_vm.layout.box1?.messageContent?.text)}})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }